export default "__VITE_ASSET__a5d9f767__"